/**
 * Created by n.gorte on 28.06.2017.
 */
import React from 'external/react';
import PropTypes from 'external/prop-types';
import * as DataUtil from '../utils/data-util.js';
import shallowEqual from '../utils/shallowEqual';
import debounce from '../utils/debounce';

const dataListHOC = (WrappedComponent) => {

    class DataListHOC extends React.Component {

        constructor(props) {
            super(props);
            const { activeIds, disabledIds, propName } = props;

            this.state = {
                activeIds: DataUtil.idMap(activeIds, propName),
                disabledIds: DataUtil.idMap(disabledIds, propName),
                didScrollToSelected: false
            };

            this.loadMoreRows = debounce(this.loadMoreRows.bind(this), 500);
            this.pendingLoadingRows = [];
        }

        scrollToItemId(id, listEnd) {
            const list = DataUtil.asArray(this.props.list);

            if (!list) {
                console.warn('list as Array is false in DataListHoc', this.props.list);
            } else {
                const { propName } = this.props,
                    idx = list.findIndex(item => propName ? item[propName] : item.id === id);

                if (idx >= 0) {
                    if (this.wc && this.wc.scrollToIndex) {
                        this.wc.scrollToIndex(idx);
                    } else {
                        console.warn('Cannot call scrollToIndex on', this.wc);
                    }
                    this.setState({
                        didScrollToSelected: true
                    });
                } else {
                    /*const startIndex = list._end;
                    this.loadMoreRows({ stopIndex: startIndex + 25 });*/
                    if (this.wc && this.wc.scrollToIndex) {
                        this.wc.scrollToIndex(listEnd - 1);

                    } else {
                        console.warn('Cannot call scrollToIndex on', this.wc);
                    }
                    this.setState({
                        didScrollToSelected: false
                    });
                }
            }
        }

        UNSAFE_componentWillReceiveProps(nextProps) {

            const { activeIds, disabledIds } = this.state;
            let nextActiveIds = activeIds, nextDisabledIds = disabledIds;

            if (!shallowEqual(this.props.activeIds, nextProps.activeIds)) {
                nextActiveIds = DataUtil.idMap(nextProps.activeIds, nextProps.propName);
            }

            if (!shallowEqual(this.props.disabledIds, nextProps.disabledIds)) {
                nextDisabledIds = DataUtil.idMap(nextProps.disabledIds, nextProps.propName);
            }

            const { list } = nextProps;
            const listItems = DataUtil.asArray(list);

            if (nextActiveIds && ((activeIds !== nextActiveIds) || !this.state.didScrollToSelected) && Object.keys(nextActiveIds).length > 0) {
                this.scrollToItemId(parseInt(Object.keys(nextActiveIds)[0]), list._end);
            }

            this.pendingLoadingRows = this.pendingLoadingRows.filter(pending => {
                if (listItems[pending.range.startIndex] &&
                    listItems[pending.range.stopIndex]) {
                    pending.resolve();
                } else {
                    return true;
                }
            });

            this.setState({
                activeIds: nextActiveIds,
                disabledIds: nextDisabledIds
            });

        }

        loadMoreRows(range) {
            const { stopIndex } = range,
                offset = stopIndex - DataUtil.asArray(this.props.list).length;

            this.props.onClickMore && this.props.onClickMore({ offset: offset + 1 });

            return new Promise(resolve => {
                this.pendingLoadingRows.push({
                    resolve,
                    range: {
                        startIndex: DataUtil.asArray(this.props.list).length - 1,
                        stopIndex
                    }
                });
            });
        }

        render() {
            const { activeIds, disabledIds } = this.state;
            // eslint-disable-next-line no-unused-vars
            const { onClickMore, ...rest } = this.props;
            return (
                <WrappedComponent
                    ref={wc => this.wc = wc}
                    loadMoreRows={this.loadMoreRows}
                    activeIds={activeIds}
                    disabledIds={disabledIds}
                    {...rest}
                />
            );
        }
    }

    DataListHOC.propTypes = {
        disabled: PropTypes.object,
        list: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array
        ]),
        activeIds: PropTypes.object,
        disabledIds: PropTypes.object,
        onClickMore: PropTypes.func,
        propName: PropTypes.string
    };

    return DataListHOC;
};

export default dataListHOC;



// WEBPACK FOOTER //
// ./js/components/DataListHoc.js